export const frontmatter = {
    "draft": false,
    "title": "Guía: Widgets",
    "description": "Cómo crear y configurar un widget de chat WebChat en OnnIA: apariencia, comportamiento, FAQs, integración y estados.",
    "sidebar_label": "Widgets",
    "sidebar_group": "referencia",
    "sidebar_order": 7
}

export const toc = [
    {
        "depth": 2,
        "id": "acceso-al-modulo",
        "value": "Acceso al módulo"
    },
    {
        "depth": 2,
        "id": "crear-un-widget",
        "value": "Crear un widget"
    },
    {
        "depth": 3,
        "id": "datos-generales",
        "value": "Datos generales"
    },
    {
        "depth": 3,
        "id": "preguntas-frecuentes-faq",
        "value": "Preguntas frecuentes (FAQ)"
    },
    {
        "depth": 3,
        "id": "visibilidad-y-posicion",
        "value": "Visibilidad y posición"
    },
    {
        "depth": 3,
        "id": "tipografia-y-colores",
        "value": "Tipografía y colores"
    },
    {
        "depth": 3,
        "id": "imagenes-y-adjuntos",
        "value": "Imágenes y adjuntos"
    },
    {
        "depth": 2,
        "id": "vista-previa",
        "value": "Vista previa"
    },
    {
        "depth": 2,
        "id": "estados-del-widget",
        "value": "Estados del widget"
    }
]